/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react"
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../helpers'
import {orderDetails} from '../../../../api/ordersApi'
import axios from '../../../../config/axiosConfig';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import fileDownload from 'js-file-download';

dayjs.extend(localizedFormat);
dayjs.locale('it');

type Props = {
  show: boolean;
  handleClose: () => void;
  recordId: number;
  statoOrdine: string | null;
};

const modalsRoot = document.getElementById('root-modals') || document.body

const ViewDetailsOrders = ({ show, handleClose, recordId, statoOrdine }: Props) => {
  const [selectedTab, setSelectedTab] = useState<'details' | 'shipping' | 'list' | 'accounting' | 'goods'>(
    'details'
  )

  const [currentOrderDetails, setCurrentOrderDetails] = useState<any>(null);
  const [previousOrders, setPreviousOrders] = useState<any[]>([]);
  const [accountantInfo, setAccountantInfo] = useState<any>([]);

  useEffect(() => {
    if (show) {
      fetchRecordDetails(recordId);
      setSelectedTab("details");
    } else {
      setSelectedTab("details");
    }
  }, [show, recordId]);


  const fetchRecordDetails = async (id: number) => {
    try {
      const response = await orderDetails(id);
  
      //Casto le date da formato americano a italiano

      let Spedizione_partenza_stimata_US = dayjs(response.currentOrderDetails[0].Spedizione_partenza_stimata);
      response.currentOrderDetails[0].Spedizione_partenza_stimata = Spedizione_partenza_stimata_US.format('LL');

      let Spedizione_partenza_effettiva_US = dayjs(response.currentOrderDetails[0].Spedizione_partenza_effettiva);
      response.currentOrderDetails[0].Spedizione_partenza_effettiva = Spedizione_partenza_effettiva_US.format('LL');

      let Spedizione_arrivo_stimato_US = dayjs(response.currentOrderDetails[0].Spedizione_arrivo_stimato);
      response.currentOrderDetails[0].Spedizione_arrivo_stimato = Spedizione_arrivo_stimato_US.format('LL');

      let Spedizione_arrivo_effettivo_US = dayjs(response.currentOrderDetails[0].Spedizione_arrivo_effettivo);
      response.currentOrderDetails[0].Spedizione_arrivo_effettivo = Spedizione_arrivo_effettivo_US.format('LL');

      let Data_entrata_ordine_US = dayjs(response.currentOrderDetails[0].Data_entrata_ordine);
      response.currentOrderDetails[0].Data_entrata_ordine = Data_entrata_ordine_US.format('LL');

      let Data_inizio_contratto_US = dayjs(response.currentOrderDetails[0].Data_inizio_contratto);
      response.currentOrderDetails[0].Data_inizio_contratto = Data_inizio_contratto_US.format('LL');

      let Prima_Data_Contratto_US = dayjs(response.currentOrderDetails[0].Prima_Data_Contratto);
      response.currentOrderDetails[0].Prima_Data_Contratto = Prima_Data_Contratto_US.format('LL');

      if(response.accountantInfo.length !== 0)
      {
        let Data_fatturazione_US = dayjs(response.accountantInfo[0].Data_fatturazione);
        response.accountantInfo[0].Data_fatturazione = Data_fatturazione_US.format('LL');

        let Data_scadenza_fattura_US = dayjs(response.accountantInfo[0].Data_scadenza_fattura);
        response.accountantInfo[0].Data_scadenza_fattura = Data_scadenza_fattura_US.format('LL');
      }
      
      let createdAt_US = dayjs(response.currentOrderDetails[0].createdAt);
      response.currentOrderDetails[0].createdAt = createdAt_US.format('LL');

      let updatedAt_US = dayjs(response.currentOrderDetails[0].updatedAt);
      response.currentOrderDetails[0].updatedAt = updatedAt_US.format('LL');

      response.previousOrders.forEach((order: any) => {
        let Data_inizio_contratto_US = dayjs(order.Data_inizio_contratto);
        order.Data_inizio_contratto = Data_inizio_contratto_US.format('LL');
      });

      if(response.currentOrderDetails[0].Durata > 12) {
        response.currentOrderDetails[0].Mesi_gratis = response.currentOrderDetails[0].Durata - 12;
      }
      else {
        response.currentOrderDetails[0].Mesi_gratis = null;
      }
      
      setCurrentOrderDetails(response.currentOrderDetails[0]);
      setPreviousOrders(response.previousOrders);
      setAccountantInfo(response.accountantInfo[0]);

    } catch (error) {
      console.error(error);
    }
  };

  const handleDownload = async (tipo: 'preventivo' | 'licenza') => {
    try {
      const { data, headers } = await axios.get(
        `/api/orders/${recordId}/documents/${tipo}`,
        { responseType: 'blob' }
      );
      // ricava il nome dal header o usa default
      const filename =
        headers['content-disposition']?.match(/filename="?(.+)"?/)?.[1] ||
        `${tipo}.pdf`;
      fileDownload(data, filename);
    } catch (err) {
      console.error(err);
      alert('Download non riuscito');
    }
  };

  return createPortal(
    <Modal
      id="kt_modal_view_details"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-900px"
      show={show}
      onHide={handleClose}
    >
      <div className="modal-header">
        <h2>Dettagli Ordine</h2>
        {/* begin::Close */}
        <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
          <KTSVG className="svg-icon-1" path="/media/icons/duotune/arrows/arr061.svg" />
        </div>
        {/* end::Close */}
      </div>

      <div className="modal-body">
      <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
        <li className="nav-item mx-lg-1">
          <a
            role="tab"
            onClick={() => setSelectedTab('details')}
            className={`nav-link py-3 py-lg-6 text-active-primary
                        ${selectedTab === 'details' ? 'active' : ''}`}
          >
            Cliente
          </a>
        </li>

        <li className="nav-item mx-lg-1">
          <a
            role="tab"
            onClick={() => setSelectedTab('goods')}
            className={`nav-link py-3 py-lg-6 text-active-primary
                        ${selectedTab === 'goods' ? 'active' : ''}`}
          >
            Servizi e Prodotti
          </a>
        </li>

        <li className="nav-item mx-lg-1">
          <a
            role="tab"
            onClick={() => setSelectedTab('shipping')}
            className={`nav-link py-3 py-lg-6 text-active-primary
                        ${selectedTab === 'shipping' ? 'active' : ''}`}
          >
            Spedizione
          </a>
        </li>

        <li className="nav-item mx-lg-1">
          <a
            role="tab"
            onClick={() => setSelectedTab('accounting')}
            className={`nav-link py-3 py-lg-6 text-active-primary
                        ${selectedTab === 'accounting' ? 'active' : ''}`}
          >
            Contabilità
          </a>
        </li>

        <li className="nav-item mx-lg-1">
          <a
            role="tab"
            onClick={() => setSelectedTab('list')}
            className={`nav-link py-3 py-lg-6 text-active-primary
                        ${selectedTab === 'list' ? 'active' : ''}`}
          >
            Ordini&nbsp;precedenti
          </a>
        </li>
      </ul>

        <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        {currentOrderDetails && (
            selectedTab === "details" ? (
        /* -------------- SEZIONE INFORMAZIONI ----------------------- */
        <div className="row"> {/* Contenitore esterno della griglia */}
          <div className="col-md-6"> {/* Contenitore della colonna sinistra */}
            <div className='card-body p-9'>
              {/* Blocco 1: Dati generali */}
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Partita IVA</label>

                <div className='col-lg-8 fv-row'>
                  <span className='fw-bold fs-6'>{currentOrderDetails.P_IVA === null ? "-" : currentOrderDetails.P_IVA}</span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>
                  Codice fiscale
                </label>

                <div className='col-lg-8 d-flex align-items-center'>
                  <span className='fw-bolder fs-6 me-2'>{currentOrderDetails.CF === null ? "-" : currentOrderDetails.CF}</span>
                </div>
              </div>   

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Email 1</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Email === null ? "-" : currentOrderDetails.Email}</span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>
                Email 2
                </label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Email_2 === null ? "-" : currentOrderDetails.Email_2}</span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>
                Referente cliente
                </label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Referente_commerciale === null ? "-" : currentOrderDetails.Referente_commerciale}</span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Intermediario</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Nome_intermediario === null ? "No" : currentOrderDetails.Nome_intermediario}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        ) : selectedTab === "goods" ? (
          /* -------------- SEZIONE SERVIZI E PRODOTTI ----------------------- */
          <div className="row">
            <div className="col-md-12">
            <div className='card-body p-9'>
              {/* Blocco 2: Simulazioni scelte */}
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Piano</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Nome_piano === null ? "-" : currentOrderDetails.Nome_piano}</span>
                    </div>
                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Mesi gratis</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Mesi_gratis === null ? "0" : currentOrderDetails.Mesi_gratis}</span>
                    </div>
                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Simulazioni scelte</label>

                    <div className='col-lg-8'>
                        {currentOrderDetails.Nome_piano === "Matrix" ? (
                            <span className='fw-bolder fs-6 text-dark'>Tutte</span>
                        ) : (
                            <ul>
                                {currentOrderDetails.Simulazioni.split(',').map((simulazione: string, index: number) => (
                                    <li key={index} className='fw-bolder fs-6 text-dark'>
                                        {simulazione.trim()}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Opzione aggiuntive scelte</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Opzioni_aggiuntive === null ? "-" : currentOrderDetails.Opzioni_aggiuntive}</span>
                    </div>
                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Modello visori</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.ModelliConteggio === null ? "-" : currentOrderDetails.ModelliConteggio}</span>
                    </div>
                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Seriali visori</label>

                    <div className='col-lg-8'>
                      {currentOrderDetails.Numeri_seriali_visori_attivi && currentOrderDetails.Numeri_seriali_visori_attivi !== 'N/A' && (
                          <ul>
                              {currentOrderDetails.Numeri_seriali_visori_attivi.split(',').map((seriale_att: string, index: number) => (
                                  <li key={index} className='fw-bolder fs-6 text-dark'>
                                      {seriale_att.trim()}
                                  </li>
                              ))}
                          </ul>
                      )}
                      {statoOrdine === 'Inattivo' && currentOrderDetails.Numeri_seriali_visori_inattivi && currentOrderDetails.Numeri_seriali_visori_inattivi !== 'N/A' && (
                          <ul>
                              {currentOrderDetails.Numeri_seriali_visori_inattivi.split(',').map((seriale_inatt: string, index: number) => (
                                  <li key={index} className='fw-bolder fs-6 text-dark'>
                                      {seriale_inatt.trim()}
                                  </li>
                              ))}
                          </ul> 
                      )}
                    </div>
                </div>
                {/*<div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Sconto</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Percentuale_sconto}%</span>
                    </div>
                </div>*/}
            </div>
            </div>
          </div>
        ) : selectedTab === "shipping" ? (
          /* -------------- SEZIONE SPEDIZIONE ----------------------- */
          <div className='row'>
            <div className='col-md-12'>
              <div className='card-body p-9'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Corriere</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_corriere ?? "-"}
                    </span>
                  </div>
                </div>
          
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Costo</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_costo === null
                        ? "-"
                        : `${currentOrderDetails.Spedizione_costo} €`}
                    </span>
                  </div>
                </div>
          
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Partenza stimata</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_partenza_stimata === "Invalid Date"
                        ? "-"
                        : currentOrderDetails.Spedizione_partenza_stimata}
                    </span>
                  </div>
                </div>
          
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Partenza effettiva</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_partenza_effettiva === "Invalid Date"
                        ? "-"
                        : currentOrderDetails.Spedizione_partenza_effettiva}
                    </span>
                  </div>
                </div>
          
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Arrivo stimato</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_arrivo_stimato === "Invalid Date"
                        ? "-"
                        : currentOrderDetails.Spedizione_arrivo_stimato}
                    </span>
                  </div>
                </div>
          
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Arrivo effettivo</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {currentOrderDetails.Spedizione_arrivo_effettivo === "Invalid Date"
                        ? "-"
                        : currentOrderDetails.Spedizione_arrivo_effettivo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : selectedTab === "accounting" ? (
          /* -------------- SEZIONE CONTABILITÀ ----------------------- */
          <div className="row">
          <div className="col-md-6"> {/* Contenitore della colonna destra */}
            <div className='card-body p-9'>
              {/* Blocco 3: Dettagli di pagamento e date ordine */}
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Metodo di pagamento</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Metodo_pagamento === null ? "-" : currentOrderDetails.Metodo_pagamento}</span>
                    </div>

                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Modalità di pagamento</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Modalita_pagamento === null ? "-" : currentOrderDetails.Modalita_pagamento}</span>
                    </div>

                </div>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Data entrata primo ordine</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Data_entrata_ordine === "Invalid Date" ? "-" : currentOrderDetails.Data_entrata_ordine}</span>
                    </div>

                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Data inizio ultimo contratto</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Data_inizio_contratto === "Invalid Date" ? "-" : currentOrderDetails.Data_inizio_contratto}</span>
                    </div>

                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Note</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.Note === null ? "-" : currentOrderDetails.Note}</span>
                    </div>

                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Creato il</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.createdAt === null ? "-" : currentOrderDetails.createdAt}</span>
                    </div>

                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Modificato il</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.updatedAt === null ? "-" : currentOrderDetails.updatedAt}</span>
                    </div>

                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Creato da</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.createdBy === null ? "-" : currentOrderDetails.createdBy}</span>
                    </div>
                </div>

                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Modificato da</label>

                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark'>{currentOrderDetails.updatedBy === null ? "-" : currentOrderDetails.updatedBy}</span>
                    </div>
                </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Importo fattura</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {accountantInfo?.Importo_fattura ? `${accountantInfo.Importo_fattura} €` : '-'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Data fatturazione</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {accountantInfo?.Data_fatturazione ?? '-'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Scadenza fattura</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {accountantInfo?.Data_scadenza_fattura ?? '-'}
                  </span>
                </div>
              </div>
            </div>
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Preventivo firmato</label>
                <div className='col-lg-8'>
                  {accountantInfo?.Path_preventivo_firmato ? (
                    <button className='btn btn-sm btn-primary'
                            onClick={() => handleDownload('preventivo')}>
                      Scarica
                    </button>
                  ) : (
                    <span className='text-muted'>non presente</span>
                  )}
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Licenza d'uso</label>
                <div className='col-lg-8'>
                  {accountantInfo?.Path_licenza_uso ? (
                    <button className='btn btn-sm btn-primary'
                            onClick={() => handleDownload('licenza')}>
                      Scarica
                    </button>
                  ) : (
                    <span className='text-muted'>non presente</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            
          </div>
        </div>
        ) : (
        /* -------------- SEZIONE ORDINI PRECEDENTI ----------------------- */
        <div className="row">
          <div className="col-md-6"> {/* Contenitore della colonna sinistra */}
            <div className='card-body p-9'>
                <div className='row mb-7'>
                    <label className='col-lg-4 fw-bold text-muted'>Data inizio contratto/i</label>

                    <div className='col-lg-8'>
                        {previousOrders.length === 0 ? (
                            <span className='fw-bolder fs-6 text-dark'>Nessun ordine precedente</span>
                        ) : (
                            <ul>
                            {previousOrders.map((order, index) => (
                              <li key={index} className='fw-bolder fs-6 text-dark'>{order.Data_inizio_contratto}</li>
                            ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
          </div>
        </div>
        )
        )}
          </div>
        </div>
      </Modal>,
    modalsRoot
  );
};

export { ViewDetailsOrders };